module.exports = __webpack_public_path__ + "img/数鸽@2x.0109d564.png";